export default __webpack_public_path__ + "static/hq14-3e8bdf4c5ff605dc97e562a1d1bf5783.jpg";